import React, {Component} from 'react'
import {Field} from 'redux-form'
import {ButtonGroup, Col, Form, Row} from 'react-bootstrap'

export default class RadioField extends Component {

	renderRadio(props) {
		const {
			input,
			label,
			meta: {error, warning, touched},
			disabled,
			onChangeHook
		} = props;

		let message;
		const validationState = touched ? (error && "danger") || (warning && "warning") || (!props.disabled && input.value ? "success" : null) : null;

		if (touched && (error || warning)) {
			message = error || warning;
		}

		return (
			<label className={"btn " + (input.checked ? "btn-info" : "btn-outline-secondary") + " " + (disabled && "disabled") + " " + validationState}>
				{label}
				<input type="checkbox" disabled={disabled} {...input}
					onChange={(event) => {
						if (onChangeHook) {
							onChangeHook(event)
						}
						input.onChange(input.value)
					}}
					onBlur={() => {
						input.onChange(input.value)
					}}
					title={message}/>
			</label>
		)
	}

	renderOptions(name, options, disabled, onChangeHook) {
		let buttons = [];

		for (let i = 0; i < options.length; i++) {
			buttons.push(<Field key={i} name={name} type="radio" component={this.renderRadio} value={options[i].value} label={options[i].label} disabled={disabled}
				onChangeHook={onChangeHook}/>)
		}

		return buttons
	}

	render() {
		const {
			input,
			label,
			meta: {error, warning, touched},
			sizes,
			options,
			disabled,
			onChangeHook
		} = this.props;

		let message;
		const validationState = touched ? (error && "danger") || (warning && "warning") || null : null;

		if (touched && (error || warning)) {
			message = error || warning;
		}

		const labelS = sizes && sizes[0] !== undefined ? sizes[0] : 4;
		const inputS = sizes && sizes[1] !== undefined ? sizes[1] : 8;
		return (
			<Form.Group as={Row} controlId={input.name}>
				{label && labelS ? <Form.Label column xs={labelS}>{label}</Form.Label> : null}
				<Col xs={inputS}>
					<ButtonGroup data-toggle="buttons" className={(touched && error ? " is-invalid" : "")}>
						{this.renderOptions(input.name, options, disabled, onChangeHook)}
					</ButtonGroup>
					{message ? <div className={"text-" + validationState}>{message}</div> : null}
				</Col>
			</Form.Group>
		);
	}
}
